export const isValidPolicyFilter = ({
    label,
    calcfocusData,
    status,
}: {
    label: string;
    calcfocusData: any;
    status: string;
}) => {
    return label === 'Instant IUL' && calcfocusData && status !== 'declined';
};
